// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 362 ? "Dashboard" : chunkId) + "." + {"91":"a8626b38","362":"a8626b38","833":"a8626b38","977":"a8626b38"}[chunkId] + ".chunk.css";
};